import { useState,useEffect, useRef, useContext } from "react"
import { ActionTypes, AppContext } from "../store/AppStore";
import { AxiosCentrasService, AxiosInstance, DialogType, ModalpropsCustom } from "../utils/constants";

const useUploadFile = ({
    default_value="",
    keyValue,
    code_entity_save,
    setImageValue,
    update_image_product=true


})=>{



const [image_url,setImageUrl] = useState(default_value);
const InputUploadRet = useRef(null);
const {dispatch,store} = useContext( AppContext );

useEffect(()=>{
    if ( default_value ){
        setImageUrl(default_value);
    }
},[default_value]);

const clickUploadFile = (evt)=>{
    InputUploadRet.current.click();

}

const onSelectFile = async(evt)=>{
 const File = InputUploadRet.current.files[0];

 if ( (File.size/1000) > 1000){
    dispatch({
        type:ActionTypes.setModalInfo,
        data:{
            isVisible:true,
            title:"Archivo muy grande",
            message:"El archivo es muy pesado, lo recomendado seria menos de 1MB"
        }
    });
    return ;
 }


 var formData = new FormData();
 formData.append("file", File);
 const responseResult = await AxiosCentrasService.post("UploadFile",formData);
 let {data:{imageName}} = responseResult;
/*  if (update_image_product){
     const saveProdImagenResult = await AxiosInstance.post("maestros-marketplace/set-product-image",{
         cod_prod:code_entity_save,
         imagen:imageName
     });
 } */
 

 setImageUrl(imageName);
 setImageValue(imageName);
try{



}catch(e){

    console.log({messageCatch:e.message});
    dispatch({
        type:ActionTypes.setModalInfo,
        data:{
            type:DialogType.peligro,
            isVisible:true,
            title:"Error",
            message:"No se pude subir el archivo por favor verifique su conexion a internet"
        }
    });

}
 

}

const InputFileRaw =  ()=>  <input onChange={onSelectFile} ref={InputUploadRet} id={keyValue} hidden type="file" accept="image/png,image/jpeg" />

return {
    image_url,
    setImageUrl,
    clickUploadFile,
    InputFileRaw
}

}

export{
    useUploadFile
}